import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '../../atoms/PrimaryButton'
import SecondaryButton from '../../atoms/SecondaryButton'
import FullScreenPopup from '../../organisms/FullScreenPopup'
import ProductCommonContext from '../../../context/common/commonContext'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../common/components'
import Loaders from '../../molecules/Loaders'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import BaseActionPage from '../../species/dynamic/common/BaseActionPage'
import AuctionContext from '../../../context/auction/auctionContext'
import ProductContext from '../../../context/product/productContext'
import SettingContext from '../../../context/setting/settingContext'
import SellerBidContext from '../../../context/bid/bidContext'
import TemplateContext from '../../../../product/context/template/auction/auctionContext'

import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'

let randomVariable = Math.random()

const AuctionFieldsView = (props) => {
    const auctionContext = useContext(AuctionContext)
    const settingContext = useContext(SettingContext)
    const sellerBidContext = useContext(SellerBidContext)
    const templateContext = useContext(TemplateContext)
    const customCommonContext = useContext(CustomCommonContext)

    const { t } = useTranslation()
    const { allConfigurationVariables } = customCommonContext
    const { bid_increments, getAllBidIncrements } = settingContext
    const {
        single_auction,
        auction_projects,
        getSingleAuction,
        getAllAuctProjects,
        auctionAction,
        responseStatus: AuctionResponseStatus,
    } = auctionContext
    const {
        single_auction: template_SingleValue,
        getSingleAuction: template_GetSingleValue,
    } = templateContext

    const {
        all_increments,
        bidIncrementAction,
        changeBidIncrementStatus,
        responseStatus: responseStatusSellerBid,
    } = sellerBidContext
    const ups_engine_carrier_id = 'se-719206'
    const ups_engine_carrier_code = 'ups'

    const usps_engine_carrier_id = 'se-719205'
    const usps_engine_carrier_code = 'stamps_com'
    const station_carrier_code = 'fedex'
    const station_service_code = 'fedex_ground'
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [tempArray, setTempArray] = useState([])

    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])

    const [formikValues, setFormikValues] = useState({})
    const [activeAuctProjects, setActiveAuctProjects] = useState([])

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])
    const [singleRecord, setSingleRecord] = useState([])

    useEffect(() => {
        let customValidationTemp = {}

        let customInitial = {
            ...(props.customInitial ? { ...props.customInitial } : {}),
            id: 0,
            project_status: 'draft',
            engine_carrier_id: '',
            engine_carrier_code: '',

            // shipping: 'shipEngine',
        }

        customValidationTemp = {
            ...props.customValidation,
            date_added: Yup.date(t('Please enter valid Date!'))
                .nullable()
                .typeError(t('Required!'))
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  new Date(value.replace(/-/g, '/'))
                              ).subtract(1, 'minutes')
                          )
                        : new Date(moment(value).subtract(1, 'minutes'))
                )
                .required(t('Required!')),
            date_closed: Yup.date(t('Please enter valid Date!'))
                .typeError(t('Required!'))
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  new Date(value.replace(/-/g, '/'))
                              ).subtract(1, 'minutes')
                          )
                        : new Date(moment(value).subtract(1, 'minutes'))
                )
                .min(
                    Yup.ref('date_added'),
                    t('Should be greater than start Time')
                )
                .nullable(),
            ending_enable: Yup.boolean(),
            ending_items: Yup.number().when('ending_enable', {
                is: (end) => end === true,
                then: Yup.number().min(0, 'Not valid!').required('Required!'),
            }),
            ending_mins: Yup.number().when('ending_enable', {
                is: (end) => end === true,
                then: Yup.number().min(0, 'Not valid!').required('Required!'),
            }),
            local_pickup_check: Yup.boolean().when(
                props.shippingName ? 'shipping_check' : 'shipping_enable',
                {
                    is: false,
                    then: Yup.boolean().oneOf(
                        [true],
                        'Enable Local Pickup or Shipping'
                    ),
                }
            ),
            timed_auction: Yup.boolean().when('live_auction', {
                is: false,
                then: Yup.boolean().oneOf(
                    [true],
                    'Enable Timed or Live Auction'
                ),
            }),
            location_id: Yup.string().when('local_pickup_check', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            local_pickup_slot_timeframe: Yup.number().when(
                'local_pickup_check',
                {
                    is: true,
                    then: Yup.number()
                        .integer('Must be an integer')
                        .min(0, 'Not valid!')
                        .required('Required!'),
                }
            ),
            local_pickup_appt_per_slot: Yup.number().when(
                'local_pickup_check',
                {
                    is: true,
                    then: Yup.number()
                        .integer('Must be an integer')
                        .min(0, 'Not valid!')
                        .required('Required!'),
                }
            ),
            local_pickup_start_hour: Yup.string()
                .nullable()
                .when('local_pickup_check', {
                    is: true,
                    then: Yup.string().nullable().required('Required!'),
                }),
            local_pickup_end_hour: Yup.string()
                .nullable()
                .when('local_pickup_check', {
                    is: true,
                    then: Yup.string().nullable().required('Required!'),
                }),
            ship_station: Yup.boolean().when('shipping_enable', {
                is: true,
                then: Yup.boolean().oneOf([true], 'Required'),
            }),
            ship_service: Yup.string().when('ship_station', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            station_package_code: Yup.string().when('ship_station', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            station_warehouse: Yup.string().when('ship_station', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            bid_retract_minutes: Yup.number().when('bid_retract_check', {
                is: true,
                then: Yup.number().required('Required!'),
            }),
            bid_retract_max_count: Yup.number().when('bid_retract_check', {
                is: true,
                then: Yup.number().required('Required!'),
            }),
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((mapValue) => {
                if (mapValue.name === 'date_closed') {
                    mapValue.minDate = dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )
                    mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )}`
                    mapValue.disablePast = true
                } else if (mapValue.name === 'date_added') {
                    mapValue.disablePast = true
                } else if (mapValue.name === 'ending_items') {
                    mapValue.disabled = formikValues.ending_enable
                        ? false
                        : true
                } else if (mapValue.name === 'ending_mins') {
                    mapValue.disabled = formikValues.ending_enable
                        ? false
                        : true
                } else if (mapValue.name === 'timed_auction') {
                    mapValue.disabled = formikValues.live_auction ? true : false
                } else if (mapValue.name === 'live_auction') {
                    mapValue.disabled = formikValues.timed_auction
                        ? true
                        : false
                } else if (mapValue.name === 'local_pickup_dates') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'location_id') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_start_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_end_hour') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_appt_per_slot') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'local_pickup_slot_timeframe') {
                    mapValue.class = `${
                        formikValues.local_pickup_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'ship_station') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6 mb-3`
                } else if (mapValue.name === 'station_package_code') {
                    mapValue.class = `${
                        formikValues.ship_station &&
                        formikValues.shipping_enable
                            ? ''
                            : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'station_warehouse') {
                    mapValue.class = `${
                        formikValues.ship_station &&
                        formikValues.shipping_enable
                            ? ''
                            : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'ship_service') {
                    mapValue.class = `${
                        formikValues.ship_station &&
                        formikValues.shipping_enable
                            ? ''
                            : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'bid_retract_minutes') {
                    mapValue.class = `${
                        formikValues.bid_retract_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'bid_retract_max_count') {
                    mapValue.class = `${
                        formikValues.bid_retract_check ? '' : 'd-none'
                    } col-sm-6 col-6`
                }

                if (props.customShow && Object.keys(props.customShow).length) {
                    let customShow = props.customShow
                    if (customShow.auctionGroup) {
                        if (mapValue.name === 'auction_groups') {
                            mapValue.class = `${
                                formikValues.isPrivate ? '' : 'd-none'
                            } col-sm-6 col-6`
                        }
                    }

                    if (customShow.bidLimitAuction) {
                        if (mapValue.name === 'bid_limit') {
                            mapValue.class = `${
                                formikValues.bid_limit_auction ? '' : 'd-none'
                            } col-sm-6 col-6`
                        }
                    }
                }
            })
            if (formikValues.shipping_carrier) {
                if (formikValues.shipping_carrier === 'ups') {
                    formikValues.engine_carrier_id = ups_engine_carrier_id
                    formikValues.engine_carrier_code = ups_engine_carrier_code
                } else if (formikValues.shipping_carrier === 'usps') {
                    formikValues.engine_carrier_id = usps_engine_carrier_id
                    formikValues.engine_carrier_code = usps_engine_carrier_code
                } else {
                    formikValues.engine_carrier_id = ''
                    formikValues.engine_carrier_code = ''
                }
            } else if (formikValues.ship_station) {
                formikValues.station_carrier_code = station_carrier_code
                formikValues.station_service_code = station_service_code
            }

            // if (!formikValues.local_pickup_check) {
            //     formikValues.location_id = []
            // }
            setReload(!reload)
            // setMapDataValue(tempMapData)
            // setResetMapData(true)
        }
    }, [formikValues])

    useEffect(() => {
        if (auction_projects.from === randomVariable) {
            let activeAuctProjects = []
            if (auction_projects && auction_projects.records.length > 0) {
                auction_projects.records.map((lot, index) => {
                    activeAuctProjects.push({
                        value: lot.id,
                        show:
                            props.itemDropId && props.itemDropId.length
                                ? props.itemDropId.map((ele, index) => {
                                      const colon =
                                          index !== props.itemDropId.length - 1
                                              ? ':'
                                              : ''
                                      return `${lot[ele]} ${colon} `
                                  })
                                : props.showLotID
                                  ? `${lot.id}: ${lot.title} `
                                  : `${index + 1}: ${lot.title} `,
                    })
                })
                setActiveAuctProjects(activeAuctProjects)
            } else {
                setActiveAuctProjects([])
                setIsLoading(false)
            }
        }
    }, [auction_projects])

    useEffect(() => {
        let dataValue = props.fieldValue
        if (dataValue.length) {
            dataValue.map((data, index) => {
                if (data.name === 'project_id') {
                    data.options = activeAuctProjects ? activeAuctProjects : []
                }
            })
            setTempArray(dataValue)
            setReload(!reload)
            setIsLoading(false)
        }
    }, [props.fieldValue, activeAuctProjects])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = (submitValues) => {
        setIsLoading(true)
        const value = submitValues
        if (data.status === 'new') {
            value.id = 0
        }
        // if (value.market_status === 'draft') {
        //     if (value.date_added) {
        //         value.date_added = moment(value.date_added, 'MM-DD-YYYY h:mm a').format()
        //     } else if (value.date_closed) {
        //         value.date_closed = moment(value.date_closed, 'MM-DD-YYYY h:mm a').format()
        //     }
        // }
        const dates_arr = []
        if (value.local_pickup_dates && value.local_pickup_dates.length) {
            if (value.local_pickup_dates !== '0000-00-00') {
                value.local_pickup_dates.forEach((date) => {
                    if (typeof date === 'string') {
                        dates_arr.push(date)
                    } else {
                        let d = moment
                            .utc({
                                year: date.year,
                                month: date.month.number - 1,
                                day: date.day,
                            })
                            .format('YYYY-MM-DD')
                        dates_arr.push(d)
                    }
                })
            }
        }

        // Boxbids - Unassign lots from an active auction (Change market_status, auctionid and remove bidding history)
        if (
            allConfigurationVariables?.remove_lots_from_active_auction &&
            data.status == 'edit'
        ) {
            const currLotsObj = {}
            const prevLots = single_auction?.record?.auction_lots
                ?.split(',')
                .map(Number)

            if (prevLots) {
                value.project_id.map((x) => (currLotsObj[x] = 1))
                value.remove_active_lots = prevLots.filter(
                    (lot) => !currLotsObj[lot]
                )
            }
        }

        value.date_added = value.date_added ? new Date(value.date_added) : null
        value.date_closed = value.date_closed
            ? new Date(value.date_closed)
            : null
        value.local_pickup_dates = dates_arr
        if (global?.location_equal_location_id) {
            if (value.location) {
                value.location_id = parseInt(value.location, 10)
            }
        }
        auctionAction(value)
    }

    const formSubmit = (value, data) => {
        let newValue = value
        newValue.market_status = data
        newValue.project_status = data

        setFormikValues(newValue)
        // setFormikValues({
        //     ...formikValues,
        //     market_status: data,
        // })
        submitFunction(newValue)
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status !== 'edit') {
            if (data.status === 'new') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data.id])

    useEffect(() => {
        const buttonDataTemp = []
        if (formikValues.id) {
            if (
                data.status === 'edit' &&
                single_auction?.record?.market_status === 'draft'
            ) {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: 'Save as Draft',
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Submit',
                    additionalValue: 'open',
                })
            }
            if (
                data.status === 'edit' &&
                single_auction?.record?.market_status === 'open'
            ) {
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Update',
                    additionalValue: 'open',
                })
            }
            if (data.status === 'use') {
                buttonDataTemp.push({
                    type: 'button',
                    style: 'secondary',
                    label: 'Save as Draft',
                    additionalValue: 'draft',
                })
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: 'Submit',
                    additionalValue: 'open',
                })
            }
        } else {
            buttonDataTemp.push({
                type: 'button',
                style: 'secondary',
                label: 'Save as Draft',
                additionalValue: 'draft',
            })
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Submit',
                additionalValue: 'open',
            })
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, data, single_auction])

    useEffect(() => {
        setIsLoading(true)
        if (data.popup) {
            if (data.id && data.status === 'edit') {
                randomVariable = Math.random()
                getAllAuctProjects(
                    { id: data.id, filters: props.projectFilter || null },
                    randomVariable
                )
            } else if (data.status === 'new') {
                randomVariable = Math.random()
                getAllAuctProjects(
                    { filters: props.projectFilter || null },
                    randomVariable
                )
            }
        }
    }, [data.popup])

    useEffect(() => {
        if (props.customBidIncrement) {
            getAllBidIncrements({
                searchterm: '',
                page: 1,
                limit: 100,
                order: '',
                orderby: '',
            })
        }
    }, [props.customBidIncrement])

    useEffect(() => {
        if (AuctionResponseStatus) {
            if (AuctionResponseStatus.status === 'success') {
                cancelSubmit()
                if (
                    AuctionResponseStatus.data.auction_id &&
                    props.customBidIncrement
                ) {
                    if (data.status === 'new' || data.status === 'use') {
                        let bidIncrements = bid_increments.records.map(
                            (increment) => {
                                delete increment.id
                                let eventType = { ...increment }
                                eventType.auction_id =
                                    AuctionResponseStatus.data.auction_id
                                return eventType
                            }
                        )
                        bidIncrementAction(
                            { array: true, data: bidIncrements },
                            true
                        )
                    }
                }
            }
        }
    }, [AuctionResponseStatus, bid_increments])

    return props.standalone ? (
        <>
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <BaseActionPage
                                arrayValue={tempArray}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                editFunction={getSingleAuction}
                                editValue={single_auction}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                buttonAction={buttonData}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                template_SingleValue={template_SingleValue}
                                template_GetSingleValue={
                                    template_GetSingleValue
                                }
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </>
    ) : (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? props.addModaltitle
                        ? props.addModaltitle
                        : 'ADD NEW AUCTION'
                    : props.editModaltitle
                      ? props.editModaltitle
                      : `EDIT AUCTION`
            }
            open={
                data.status === 'new' ||
                data.status === 'edit' ||
                data.status === 'use'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                ;(setIsLoading(false), toggleFullScreenPopup(false, '', 0))
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            <BaseActionPage
                                arrayValue={tempArray}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                editFunction={getSingleAuction}
                                editValue={single_auction}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                buttonAction={buttonData}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                template_SingleValue={template_SingleValue}
                                template_GetSingleValue={
                                    template_GetSingleValue
                                }
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default AuctionFieldsView
